import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BrowseIndexError } from '../../models';

/**
 * ErrorState — Presentation Component
 *
 * Displayed when an API request fails.
 * Shows the translated error message and a retry button if the error is retryable.
 */
@Component({
  selector: 'app-error-state',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './error-state.component.html',
  styleUrl: './error-state.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorStateComponent {
  /** The error to display */
  @Input({ required: true }) error!: BrowseIndexError;

  /** Emitted when user clicks the retry button */
  @Output() retry = new EventEmitter<void>();
}
